import { render, staticRenderFns } from "./List-Order-Cancel.vue?vue&type=template&id=84ac187a"
import script from "./List-Order-Cancel.vue?vue&type=script&lang=js"
export * from "./List-Order-Cancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports